import React from 'react';
import PropTypes from 'prop-types';
import { Auth0Provider } from '@auth0/auth0-react';

import { EIGHT_BASE } from '../../config-global';

// Use localStorage so tokens survive reload and we avoid hitting authorize on every refresh.
// If you see 400 on authorize in Network tab, add this URL to Auth0 Application → Allowed Callback URLs:
//   http://localhost:3000/auth/callback (and your production callback URL).
const redirectUri = typeof window !== 'undefined' ? `${window.location.origin}/auth/callback` : '';

export const Auth0SPAViewModel = (props) => {
  const { children } = props;
  return (
    <Auth0Provider
      domain={EIGHT_BASE.auth0Domain}
      clientId={EIGHT_BASE.auth0SpaClientId}
      authorizationParams={{
        redirect_uri: redirectUri,
      }}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

Auth0SPAViewModel.propTypes = {
  children: PropTypes.node,
};

